import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-all_types_of_ticket_creation-submit';
/**
 * Capture all types of ticket creation including phone, chat, email, logged-out tickets
 */
export function trackHelpCenterAllTypesOfTicketCreationSubmit(retailerToken, brandToken, brandOrderToken, UserEmail, PhoneNumber2, Subject3, Details4, IssueType5, TicketType6, TicketId7, InputEmail8, AdditionalNote9, userToken = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            retailerToken,
            brandToken,
            brandOrderToken,
            UserEmail,
            PhoneNumber2,
            Subject3,
            Details4,
            IssueType5,
            TicketType6,
            TicketId7,
            InputEmail8,
            AdditionalNote9,
            userToken,
        },
    });
}
